import { Capacitor } from '@capacitor/core';
import {
    ximiUserManager,
    ximiOidcClient,
    XIMI_NATIVE_POST_LOGOUT_URI
} from '../../utilities/ximi/oidcConfig';
import { openXimiAuthBrowser } from '../../utilities/ximi/openXimiAuthBrowser';

/**
 * Logout SSO Ximi : termine la session côté AuthProvider (end_session → efface le cookie
 * Xelya.Auth, empêche l'auto-reconnexion silencieuse) puis vide le user oidc local.
 * No-op si aucune session oidc (utilisateur classique login/mot de passe).
 */
export async function signOutXimiSso(): Promise<void> {
    const user = await ximiUserManager.getUser();
    if (!user) return;

    if (!Capacitor.isNativePlatform()) {
        await ximiUserManager.signoutRedirect(); // web : redirect complet vers end_session
        return;
    }

    // Natif : end_session dans la WebView, interception du post-logout, puis vidage local.
    const request = await ximiOidcClient.createSignoutRequest({
        id_token_hint: user.id_token,
        post_logout_redirect_uri: XIMI_NATIVE_POST_LOGOUT_URI
    });
    const callbackUrl = await openXimiAuthBrowser(request.url, XIMI_NATIVE_POST_LOGOUT_URI);
    try {
        if (callbackUrl) await ximiUserManager.signoutCallback(callbackUrl);
        else await ximiUserManager.removeUser();
    } catch {
        await ximiUserManager.removeUser(); // fallback : au minimum vider le local
    }
}
